import {Injectable} from '../di';
import {BehaviorSubject} from 'rxjs';
import {AppConfig} from './app-config';
import {DEFAULT_APP_CONFIG} from './default-config';
import {deepMerge} from '../utils/deep-merge';

/**
 * Module for handling configs
 */
@Injectable()
export class ConfigService {
  public readonly config$ = new BehaviorSubject<AppConfig>(DEFAULT_APP_CONFIG);

  public get config(): AppConfig {
    return this.config$.getValue();
  }

  constructor() {
    // todo legacy

    // default records for global object records. It will be overridden in `tv/config.js` file.
    window.tv_daemon_url = 'http://10.12.0.200:8080/';
    window.tv_channellist_type = 'mosaic';
    window.tv_auth_function = undefined;
    window.tv_key_source = 'off';

    window.CONFIG = {
      /**
       * Default config
       */
      config_default: DEFAULT_APP_CONFIG,

      /**
       * Currently loaded config
       */
      config_loaded: undefined,
      test: () => {
        // just for reference. Function is redefined in ConfigLoaderService.
        console.log(`[CONFIG] Loading error!`);
        return false;
      },
    };

    this.config$.subscribe((cfg) => {
      // TODO legacy
      window.config = cfg;
      window.CONFIG.config_loaded = cfg;
    });
  }

  /**
   * Apply additional configuration.
   */
  public applyConfig(config: AppConfig | Partial<AppConfig>) {
    const oldCfg = {...this.config$.getValue()};
    const newCfg = deepMerge(oldCfg, config) as AppConfig;
    // TODO validate config with Zod
    this.config$.next(newCfg);
  }
}

declare global {
  interface Window {
    CONFIG: {
      config_default: AppConfig;
      config_loaded: AppConfig | undefined;
      test: () => boolean;
    };
  }
}
